module.exports = __webpack_public_path__ + "static/media/R.049c413b.jpg";